<!-- src/components/Pagination.vue -->
<template>
    <nav aria-label="Page navigation example">
        <ul class="pagination pg-blue justify-content-center">
            <!-- Botón para retroceder a la página anterior, solo visible si no estás en la página 1 -->
            <li class="page-item" v-if="currentPage > 1">
                <a class="page-link Trazado-295" @click="goToPage(currentPage - 1)">
                    <!-- &laquo; -->
                    <i class="fas fa-chevron-left"></i> Anterior
                </a>
            </li>

            <!-- Primera página siempre visible -->
            <li class="page-item">
                <a class="page-link Trazado-295" :class="{ 'pagination--active': currentPage === 1 }"
                    @click="goToPage(1)">
                    1
                </a>
            </li>

            <!-- Punto suspensivo al inicio si necesario -->
            <li v-if="currentPage > 5 && totalPages >= 7" class="page-item">
                <span class="page-link Trazado-295">...</span>
            </li>

            <!-- Números de página dinámicos -->
            <li class="page-item" v-for="pageNumber in paginatedPages" :key="pageNumber">
                <a :class="pageNumber === currentPage ? 'pagination--active page-link' : 'page-link Trazado-295'"
                    @click="goToPage(pageNumber)">
                    {{ pageNumber }}
                </a>
            </li>

            <!-- Punto suspensivo al final si necesario -->
            <li v-if="currentPage < totalPages - 5 + 2 && totalPages >= 7" class="page-item">
                <span class="page-link Trazado-295">...</span>
            </li>

            <!-- Última página siempre visible, solo si hay más de una página -->
            <li class="page-item" v-if="totalPages > 1">
                <a class="page-link Trazado-295" :class="{ 'pagination--active': currentPage === totalPages }"
                    @click="goToPage(totalPages)">
                    {{ totalPages }}
                </a>
            </li>

            <!-- Botón para avanzar a la siguiente página -->
            <li class="page-item" v-if="currentPage < totalPages">
                <a @click="goToPage(currentPage + 1)" class="page-link Trazado-295">
                    <!-- &raquo; -->
                    Siguiente <i class="fas fa-chevron-right"></i>
                </a>
            </li>
        </ul>
    </nav>

</template>

<script>
export default {
    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
    },
    computed: {
        paginatedPages() {
            const pages = [];
            const visiblePages = 5; // Número de páginas que se mostrarán en el medio

            if (this.totalPages <= visiblePages + 2) {
                // Si hay menos de 7 páginas (5 + 2), mostramos todas
                for (let i = 2; i < this.totalPages; i++) {
                    pages.push(i);
                }
            } else {
                if (this.currentPage <= visiblePages) {
                    // Mostrar las primeras 5 páginas después de la primera
                    for (let i = 2; i <= visiblePages + 1; i++) {
                        pages.push(i);
                    }
                } else if (this.currentPage >= this.totalPages - visiblePages + 2) {
                    // Mostrar las últimas 5 páginas antes de la última
                    for (let i = this.totalPages - visiblePages; i < this.totalPages; i++) {
                        pages.push(i);
                    }
                } else {
                    // Mostrar 5 páginas alrededor de la página actual
                    for (let i = this.currentPage - 2; i <= this.currentPage + 2; i++) {
                        pages.push(i);
                    }
                }
            }
            return pages;
        },
    },
    methods: {
        goToPage(pageNumber) {
            if(this.currentPage !== pageNumber)
                this.$emit('page-change', pageNumber);
        },
    },
};
</script>

<style scoped>
.pagination--active {
    color: white !important;
    background-color: #025897 !important;
    border-color: #025897 !important;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.4) !important;
}
</style>